import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@/services/auth.service';
import { AppNav } from '@/routes/app-nav';
import { Observable, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    if (this.router.url.indexOf('swagger') > -1) return of(true);

    return this.authService.isAuthenticated().pipe(
      map((r) => {
        if (!r) {
          this.router.navigateByUrl('/' + AppNav.Login.route);
          return false;
        }
        return true;
      })
    );
  }
}
